/*
1	Finn Bálor	8/21/2016
—	Vacated	8/22/2016
2	Kevin Owens	8/29/2016
3	Goldberg	3/5/2017
4	Brock Lesnar	4/2/2017
5	Roman Reigns	8/19/2018
—	Vacated	10/22/2018
6	Brock Lesnar	11/2/2018
7	Seth Rollins	4/7/2019
8	Brock Lesnar	7/14/2019
9	Seth Rollins	8/11/2019
10	"The Fiend" Bray Wyatt	10/31/2019
11	Goldberg	2/27/2020
12	Braun Strowman	4/4/2020
13	"The Fiend" Bray Wyatt	8/23/2020
14	Roman Reigns	8/30/2020
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _default = [
    {
        id: "start-story-1",
        name: "Start the story",
        wrestlerIds: [
            "cody-rhodes"
        ],
        championshipId: "uni-world",
        defenses: 0,
        startDate: new Date("Apr 7, 2024")
    },
    {
        id: "uni-01",
        name: "Acknowledge Him",
        image: "//www.wwe.com/f/styles/wwe_large/public/all/2022/04/330_WM38_04032022EJ_34922--023527625597189e7da61ee840674d08.jpg",
        wrestlerIds: [
            "roman-reigns"
        ],
        championshipId: "uni-world",
        defenses: 25,
        startDate: new Date("Aug 30, 2020"),
        endDate: new Date("Apr 7, 2024")
    },
    {
        id: "uni-02",
        championshipId: "uni-world",
        endDate: new Date("Aug 30, 2020"),
        startDate: new Date("Aug 23, 2020"),
        wrestlerIds: [
            "bray-wyatt"
        ]
    },
    {
        id: "uni-03",
        championshipId: "uni-world",
        endDate: new Date("Aug 23, 2020"),
        startDate: new Date("Apr 4, 2020"),
        wrestlerIds: [
            "braun-strowman"
        ]
    },
    {
        id: "uni-04",
        championshipId: "uni-world",
        endDate: new Date("Apr 4, 2020"),
        startDate: new Date("Feb 27, 2020"),
        wrestlerIds: [
            "goldberg"
        ]
    },
    {
        id: "uni-05",
        championshipId: "uni-world",
        endDate: new Date("Feb 27, 2020"),
        startDate: new Date("Oct 31, 2019"),
        wrestlerIds: [
            "bray-wyatt"
        ]
    },
    {
        id: "uni-06",
        championshipId: "uni-world",
        endDate: new Date("Oct 31, 2019"),
        startDate: new Date("Aug 11, 2019"),
        wrestlerIds: [
            "seth-rollins"
        ]
    },
    {
        id: "uni-07",
        championshipId: "uni-world",
        endDate: new Date("Aug 11, 2019"),
        startDate: new Date("Jul 14, 2019"),
        wrestlerIds: [
            "brock-lesnar"
        ]
    },
    {
        id: "uni-08",
        championshipId: "uni-world",
        endDate: new Date("Jul 14, 2019"),
        startDate: new Date("Apr 7, 2019"),
        wrestlerIds: [
            "seth-rollins"
        ]
    },
    {
        id: "uni-09",
        championshipId: "uni-world",
        endDate: new Date("Apr 7, 2019"),
        startDate: new Date("Nov 2, 2018"),
        wrestlerIds: [
            "brock-lesnar"
        ]
    },
    {
        id: "uni-10",
        championshipId: "uni-world",
        endDate: new Date("Nov 2, 2018"),
        startDate: new Date("Aug 19, 2018"),
        wrestlerIds: [
            "roman-reigns"
        ]
    },
    {
        id: "uni-11",
        championshipId: "uni-world",
        endDate: new Date("Aug 19, 2018"),
        startDate: new Date("Apr 2, 2017"),
        wrestlerIds: [
            "brock-lesnar"
        ]
    },
    {
        id: "uni-12",
        championshipId: "uni-world",
        endDate: new Date("Apr 2, 2017"),
        startDate: new Date("Mar 5, 2017"),
        wrestlerIds: [
            "goldberg"
        ]
    },
    {
        id: "uni-13",
        championshipId: "uni-world",
        endDate: new Date("Mar 5, 2017"),
        startDate: new Date("Aug 21, 2016"),
        wrestlerIds: [
            "kevin-owens"
        ]
    },
    {
        id: "uni-14",
        championshipId: "uni-world",
        endDate: new Date("Aug 21, 2016"),
        startDate: new Date("Aug 22, 2016"),
        wrestlerIds: [
            "vacant"
        ]
    },
    {
        id: "uni-15",
        championshipId: "uni-world",
        endDate: new Date("Aug 22, 2016"),
        startDate: new Date("Aug 20, 2016"),
        wrestlerIds: [
            "finn-balor"
        ]
    }
];
